const trasnlations = {
  en: {
    home: 'Home',
    about: 'About',
    contact: 'Contact',
    skills: 'Skills',
    projects: 'Projects',
    changeLanguage: 'Change language',
  },

  pt: {
    home: 'Início',
    about: 'Sobre',
    contact: 'Contato',
    skills: 'Habilidades',
    projects: 'Projetos',
    changeLanguage: 'Mudar idioma',
  },
};

export default trasnlations;
